import { useState } from 'react';
import Modal from 'components/Modals';
import { SCREEN_SIZES } from 'style';
import { AiFillQuestionCircle } from 'react-icons/ai';
import { List, Container, Info } from './styled';

type TooltipWithIconType = {
  children: React.ReactNode;
  listItems?: string[];
  variant?: string;
  size?: string;
  left?: boolean;
  className?: string;
};

export const TooltipWithIcon = ({
  children,
  listItems,
  variant = 'light',
  size = 'normal',
  left = false,
  className
}: TooltipWithIconType) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const renderListItems = () => {
    return (
      <List>
        {listItems?.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </List>
    );
  };

  return (
    <>
      {window.innerWidth < SCREEN_SIZES.desktop && (
        <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
          {children}
          {listItems && renderListItems()}
        </Modal>
      )}
      <Container
        onClick={(e) => {
          e.stopPropagation();
          setIsModalOpen(true);
        }}
        variant={variant}
        size={size}
        className={className}
      >
        <AiFillQuestionCircle />
        {(children || listItems) && (
          <Info left={left} size={size}>
            {children}
            {listItems && renderListItems()}
          </Info>
        )}
      </Container>
    </>
  );
};

export default TooltipWithIcon;
